"use strict";
/*
 * Created on 09.01.2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");

var WorkflowStatus_1 = require("../model/WorkflowStatus");

var ActionFeasibilityConverter_1 = require("./ActionFeasibilityConverter");
/**
 * @author MSu
 */


var WorkflowStatusConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(WorkflowStatusConverter, _DataObjectConverter_);

  function WorkflowStatusConverter(statesEnum) {
    var _this;

    _classCallCheck(this, WorkflowStatusConverter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WorkflowStatusConverter).call(this));
    _this.statesEnum = statesEnum;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(WorkflowStatusConverter, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new WorkflowStatus_1.WorkflowStatus(conversions.toClassReferenceId(source.entityId), conversions.asObjectList(source, 'previousStates', function (value) {
        return conversions.asEnum(value, _this2.statesEnum);
      }), conversions.asEnum(source.currentState, this.statesEnum), conversions.asObjectList(source, 'possibleStates', function (value) {
        return conversions.asEnum(value, _this2.statesEnum);
      }), conversions.asObjectList(source, 'possibleActions', function (value) {
        return _this2.actionFeasibilityConverter.toObject(value, conversions);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        entityId: conversions.toDocumentReferenceId(source.entityId),
        previousStates: conversions.asObjectArray(source, 'previousStates', function (value) {
          return value;
        }),
        currentState: source.currentState,
        possibleStates: conversions.asObjectArray(source, 'possibleStates', function (value) {
          return value;
        }),
        possibleActions: conversions.asObjectArray(source, 'possibleActions', function (value) {
          return _this3.actionFeasibilityConverter.toDocument(value, conversions);
        })
      };
    }
  }]);

  return WorkflowStatusConverter;
}(DataObjectConverter_1.DataObjectConverter);

__decorate([typescript_ioc_1.Inject, __metadata("design:type", ActionFeasibilityConverter_1.ActionFeasibilityConverter)], WorkflowStatusConverter.prototype, "actionFeasibilityConverter", void 0);

exports.WorkflowStatusConverter = WorkflowStatusConverter;